export default {
    state: {
        isHaveAccess: false,
    },

    mutations: {
        setAccess(state, content) {
            state.isHaveAccess = content;
        },
    },

    getters: {
        checkAccess(state) {
            return state.isHaveAccess;
        }
    }
};
